import { render, staticRenderFns } from "./ReportDetailBody.vue?vue&type=template&id=1935b7a8&scoped=true"
import script from "./ReportDetailBody.vue?vue&type=script&lang=js"
export * from "./ReportDetailBody.vue?vue&type=script&lang=js"
import style0 from "./ReportDetailBody.vue?vue&type=style&index=0&id=1935b7a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1935b7a8",
  null
  
)

export default component.exports